var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BikyConfigSkillBubble",class:{
    'BikyConfigSkillBubble--active': _vm.isActive,
    'BikyConfigSkillBubble--disabled': _vm.isDisabled,
    'BikyConfigSkillBubble--dark': _vm.$vuetify.theme.dark,
  }},[_c('div',{staticClass:"BikyConfigSkillBubble__icon"},[_c('KeybeIcon',{attrs:{"color":_vm.color,"icon":_vm.icon}})],1),_c('span',{staticClass:"BikyConfigSkillBubble__title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }